import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { heritageColors } from '../../../../heritageTheme.ts';

const Cards = ({ initialData = { volunteers: { medic: [], paramedic: [], maar: [] } }, title = 'חירום והצלה', showTitle = true }) => {
  const allVolunteers = [
    ...(initialData?.volunteers?.medic || []),
    ...(initialData?.volunteers?.paramedic || []),
    ...(initialData?.volunteers?.maar || [])
  ];

  const [contacts, setContacts] = useState(allVolunteers);

  useEffect(() => {
    const updated = [
      ...(initialData?.volunteers?.medic || []).map(v => ({ ...v, type: 'medic' })),
      ...(initialData?.volunteers?.paramedic || []).map(v => ({ ...v, type: 'paramedic' })),
      ...(initialData?.volunteers?.maar || []).map(v => ({ ...v, type: 'maar' }))
    ];
    setContacts(updated);
  }, [initialData]);

  const getTypeLabel = (type) => {
    switch (type) {
      case 'medic': return { text: 'חובש', color: heritageColors.emergency };
      case 'paramedic': return { text: 'פרמדיק', color: heritageColors.gold };
      case 'maar': return { text: 'מע"ר', color: heritageColors.navy };
      default: return null;
    }
  };

  return (
    <Box sx={{ p: 3, direction: 'rtl' }}>
      {/* Header */}
      {showTitle && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <LocalHospitalIcon sx={{ color: heritageColors.emergency, fontSize: 24 }} />
          <Typography variant="h5" sx={{ color: heritageColors.navy, fontWeight: 700 }}>
            {title}
          </Typography>
        </Box>
      )}

      {/* Emergency Contacts Grid */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          borderRadius: 3,
          bgcolor: heritageColors.goldLight + '10',
          border: `2px solid ${heritageColors.gold}40`,
        }}
      >
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          gap: 1,
          flexWrap: 'wrap',
        }}>
          {contacts.map((contact) => (
            <Paper
              key={contact.id}
              elevation={0}
              sx={{
                py: 2,
                px: 3,
                borderRadius: 2,
                bgcolor: heritageColors.white,
                border: `1px solid ${heritageColors.border}`,
                minWidth: 140,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {contact.type && (
                <Box sx={{
                  bgcolor: getTypeLabel(contact.type)?.color + '20',
                  color: getTypeLabel(contact.type)?.color,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 1,
                  fontSize: '0.7rem',
                  fontWeight: 600,
                  mb: 1,
                }}>
                  {getTypeLabel(contact.type)?.text}
                </Box>
              )}
              <Typography sx={{
                fontWeight: 600,
                color: heritageColors.navy,
                fontSize: '1rem',
                mb: 1,
                textAlign: 'center',
                width: '100%',
              }}>
                {contact.name}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: '100%', justifyContent: 'center' }}>
                <PhoneIcon sx={{ fontSize: 14, color: heritageColors.gold }} />
                <Typography sx={{
                  fontSize: '0.85rem',
                  color: heritageColors.gold,
                  fontWeight: 600,
                }}>
                  {contact.phone}
                </Typography>
              </Box>
              {contact.address && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, width: '100%', justifyContent: 'center' }}>
                  <LocationOnIcon sx={{ fontSize: 14, color: heritageColors.navy }} />
                  <Typography sx={{
                    fontSize: '0.75rem',
                    color: heritageColors.navy,
                  }}>
                    {contact.address}
                  </Typography>
                </Box>
              )}
            </Paper>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default Cards;